// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c5128909","453":"4bfccf55"}[chunkId] + ".chunk.js";
};